<template>
  <vue-final-modal
    v-model="state"
    classes="modal-overlay-container"
    content-class="modern-modal-content"
    @before-close="closeDialog"
  >
    <div class="modal-header">
      <div class="header-text-container">
        <div class="title-wrapper">
          <div class="title-icon danger-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </div>
          <h5 class="modal-title">{{ displayTitle }}</h5>
        </div>
      </div>
      <button type="button" class="close-button" aria-label="Close" @click="closeDialog">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="modal-body text-center py-4">
      <p class="delete-message">{{ displayMessage }}</p>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="closeDialog">Cancel</button>
      <button type="button" class="btn btn-danger" @click="deleteItem">{{ confirmButtonText }}</button>
    </div>
  </vue-final-modal>
</template>

<script>
export default {
  name: "DeleteForm",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    id: {
      type: [Number, String, Object], // Loosened slightly to handle flexible IDs
      required: true,
    },
    message: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    confirmButtonText: {
      type: String,
      default: 'Delete'
    }
  },

  data() {
    return {
      state: this.dialog,
    };
  },

  computed: {
    // Computed properties are better than 'mounted' here to ensure reactivity
    displayTitle() {
      return this.title ? this.title : 'Delete Item';
    },
    displayMessage() {
      return this.message ? this.message : 'Are you sure you want to delete this item?';
    }
  },

  watch: {
    dialog(newVal) {
      this.state = newVal;
    },
  },

  methods: {
    deleteItem() {
      this.$emit("onChange", { delete: true, id: this.id });
      this.state = false;
    },

    closeDialog() {
      this.$emit("close");
      this.state = false;
    },
  },
};
</script>

<style scoped>
/* Inherited Modern Modal Structures */
:deep(.modal-overlay-container) {
  display: flex; justify-content: center; align-items: center;
  background-color: rgba(15, 23, 42, 0.6); backdrop-filter: blur(4px); z-index: 1000;
}
:deep(.modern-modal-content) {
  background: white; border-radius: 12px; width: 100%; max-width: 440px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); display: flex; flex-direction: column;
  border: none !important; padding: 0; margin: 0 1rem; overflow: hidden;
}

/* Header */
.modal-header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 1.25rem 1.5rem; border-bottom: 1px solid #f1f5f9; background-color: #ffffff;
}
.title-wrapper { display: flex; align-items: center; gap: 0.75rem; }
.title-icon.danger-icon {
  color: #dc3545; /* Red icon color */
  display: flex; align-items: center; justify-content: center;
  background: rgba(220, 53, 69, 0.1); /* Light red background */
  padding: 8px; border-radius: 8px;
}
.modal-title { color: #1e293b; margin: 0; font-size: 1.15rem; font-weight: 700; }
.close-button {
  background: #f1f5f9; border: none; width: 32px; height: 32px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center; cursor: pointer;
  color: #94a3b8; transition: all 0.2s;
}
.close-button:hover { background-color: #fee2e2; color: #dc3545; transform: rotate(90deg); }

/* Body */
.modal-body { padding: 1.5rem; flex-grow: 1; }
.delete-message {
  font-size: 1.05rem;
  color: #334155;
  margin: 0;
  font-weight: 500;
}

/* Footer */
.modal-footer {
  display: flex; justify-content: flex-end; border-top: 1px solid #f1f5f9;
  padding: 1rem 1.5rem; gap: 0.75rem; background-color: #f8fafc;
}
.btn {
  padding: 0.5rem 1.25rem; border-radius: 8px; font-size: 0.9rem; font-weight: 600;
  cursor: pointer; transition: all 0.2s; border: 1px solid transparent;
}
.btn-secondary { background-color: white; color: #64748b; border-color: #e2e8f0; }
.btn-secondary:hover { background-color: #f8fafc; border-color: #cbd5e1; color: #1e293b; }
.btn-danger { background-color: #ef4444; color: white; }
.btn-danger:hover { background-color: #dc2626; box-shadow: 0 4px 6px -1px rgba(220, 38, 38, 0.2); }
</style>